import { useEffect } from 'react';
import { ctGameDefault, ctGameTitle } from '../../constants/text';
import { PrivatePage } from '../../components/private-page';
import GlobalEventsManagementGrid from '../../features/global-events-management-grid';

export default function GlobalEventsManagement() {
  useEffect(() => {
    document.title = ctGameTitle + ' - Global events management';

    return () => {
      // return default value when component unmounts
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: 'dashboard' },
        { label: 'Administration', href: '../administration' },
        {
          label: 'Global Events Management',
          href: 'administration/global-events/manage'
        }
      ]}
      pageTitle={'Administration'}>
      <GlobalEventsManagementGrid />
    </PrivatePage>
  );
}
